import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'

import {GalleryImageScrollWrapper, SkeletonLoaderContainer} from './styles'

export const GalleryGridLoading = () => {
  const categories = new Array(6).fill(1)
  const images = new Array(18).fill(1)
  return (
    <Box height="100%" paddingBottom="s700">
      <Box display="flex" gap="s400" padding="s400">
        {categories.map((_, index) => (
          <SkeletonLoaderContainer
            key={`gallery-loading-category-${index}`}
            width={100}
            marginTop={0}
          />
        ))}
      </Box>
      <GalleryImageScrollWrapper className="--is-loading-wrapper">
        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap="s300">
          {images.map((_, index) => (
            <SkeletonLoaderContainer
              className="--gallery-loading-image"
              height="100%"
              marginTop={0}
              key={`gallery-loading-image-${index}`}
            />
          ))}
        </Box>
      </GalleryImageScrollWrapper>
    </Box>
  )
}
